/// <reference path="../../../typings/index.d.ts" />
/// <reference path="../apimodel.d.ts" />

module App.Common {
	'use strict';

	export interface IStateConfig {
		name?: string;
		url?: string;
		mainUrl?: string;
		leftnavUrl?: string;
	}

	export abstract class RoutesBase {

		public static $inject = ['$stateProvider'];
		constructor(protected $stateProvider: angular.ui.IStateProvider) { }

		protected templateDir: string;

		public addStateWithConfig(config: IStateConfig) {
			this.$stateProvider
				.state(config.name, {
					url: config.url,
					views: {
						'main': { templateUrl: config.mainUrl },
						'leftnav': { templateUrl: config.leftnavUrl }
					}
				});
		}

		public addState(name: string, config: IStateConfig = null) {
			this.addStateWithConfig(_.extend({
				name: name,
				url: `/${name}`,
				mainUrl: `Templates/${this.templateDir}/${name}View.html`
			}, config || {} as IStateConfig));
		}

	}

}
